// =============================================================
// SCROLL PROGRESS RAIL — vertical progress (mimari plan)
// =============================================================

import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { usePrefersReducedMotion } from "@/lib/animation/prefers-reduced-motion";
import styles from "./ScrollProgressRail.module.css";

export function ScrollProgressRail() {
  const ref = useRef<HTMLDivElement>(null);
  const reduced = usePrefersReducedMotion();

  useEffect(() => {
    if (!ref.current || reduced) return;
    const fill = ref.current.querySelector<HTMLElement>(`.${styles["scroll-progress__fill"]}`);
    if (!fill) return;

    const tween = gsap.fromTo(
      fill,
      { scaleY: 0 },
      {
        scaleY: 1,
        ease: "none",
        scrollTrigger: {
          start: 0,
          end: "max",
          scrub: 0.4,
        },
      }
    );

    return () => {
      tween.scrollTrigger?.kill();
      tween.kill();
    };
  }, [reduced]);

  return (
    <div
      ref={ref}
      className={styles["scroll-progress"]}
      aria-hidden="true"
      role="presentation"
    >
      <div className={styles["scroll-progress__track"]} />
      <div
        className={styles["scroll-progress__fill"]}
        style={{ transformOrigin: "top" }}
      />
    </div>
  );
}